import { trackAnalytics } from "services/analytics";

export const faFooterNavClick = ({ flowName, segment, lob, product }) => {
  const footerValue = "footer";
  flowName = flowName?.replace("&", "and").toLowerCase();
  segment = segment?.replace("&", "and").replace(":", "").toLowerCase();
  lob = lob?.replace("&", "and").toLowerCase();
  product = product?.replace("&", "and").toLowerCase();
  trackAnalytics({
    eVar9: `b2b${flowName ? "|" + flowName : ""}${segment ? "|" + segment : ""}${lob ? "|" + lob : ""}${
      product ? "|" + product : ""
    }`,
    prop0: `b2b${flowName ? "|" + flowName : ""}`,
    prop6: footerValue,
    prop7: segment,
    prop8: lob,
    prop9: product,
  });
};
